<template>
<div class="search-result" :class="{ empty: counter == 0 }">
    <div class="search-content">
        <span class="text">
            {{
                $trans("web_search.selected_competences").replace(
                    ":number",
                    filters.length,
                )
            }}
            <em @click="$emit('resetSearchResult')" class="reset-search">
                {{ $trans("web_search.reset_search") }}
            </em>
        </span>

        <div class="switcher-container" v-show="filters.length > 1">
            <div class="switcher">
                <span class="link-terms-span">
                    {{ $trans("web_search.link_search_terms_as") }}
                </span>

                <span
                    class="toggle-description"
                    :class="{ selected: modifier === 'AND' }"
                    @click="switchModifier('AND')"
                >
                    {{ $trans("web_search.filters.and") }}
                </span>

                <div class="toggle" @click="toggleModifier">
                    <div
                        :class="[
                            'toggle-handle',
                            { right: modifier === 'OR' },
                        ]"
                    />
                </div>

                <span
                    class="toggle-description"
                    :class="{ selected: modifier === 'OR' }"
                    @click="switchModifier('OR')"
                >
                    {{ $trans("web_search.filters.or") }}
                </span>
            </div>
        </div>
    </div>

    <div class="tag-wrapper">
        <template v-for="(option, index) in filters" :key="index">
            <Tag
                :text="option.name"
                :hover="true"
                :close="true"
                :tag-id="option.id"
                :main-filters="filters"
                @close="$emit('removeFilter', option)"
                @aiClick="(skillsIds) => $emit('showSimiliarTags', skillsIds)"
                @maxCompetencesLimitReached="$emit('maxCompetencesLimitReached')"
            />
        </template>
    </div>

    <div v-if="removedFilters.length > 0" class="removed-filters-container">
        <div class="removed-tags-list">
            <div
                v-for="filter in removedFilters"
                :key="filter.id"
                class="removed-tag"
                @click="restoreFilter(filter)"
            >
                <span class="removed-tag-text">{{ filter.name }}</span>
                <el-icon class="restore-icon">
                    <CirclePlus />
                </el-icon>
            </div>
        </div>

        <el-button class="update-btn" @click="updateSearch">
            Aktualisieren
        </el-button>
    </div>
</div>
</template>

<script>
import { Search as SearchIcon, CirclePlus } from "@element-plus/icons-vue";
import Tag from "./Utils/Tag.vue";

export default {
    components: {
        SearchIcon,
        CirclePlus,
        Tag,
    },

    props: {
        counter: {
            type: Number,
            required: true,
        },
        filters: {
            type: Array,
            required: true,
        },
        modifier: {
            type: String,
            required: true,
        },
        removedFilters: {
            type: Array,
            required: true,
        },
    },

    methods: {
        switchModifier(modifier) {
            if (modifier !== this.modifier) {
                this.$emit("switchModifier", modifier);
            }
        },

        toggleModifier() {
            const newModifier = this.modifier === "AND" ? "OR" : "AND";
            this.switchModifier(newModifier);
        },

        restoreFilter(filter) {
            this.$emit("restoreFilter", filter);
        },

        updateSearch() {
            this.$emit("updateSearch");
        },
    },
};
</script>

<style scoped>
.search-result {
    margin-top: 10px;
    font-size: 18px;
    color: #3c3c3c;
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-left: 10%;
    width: 79%;
    padding-bottom: 20px;
    border-bottom: 1px solid #343433;
    box-sizing: border-box;
}

.search-content,
.tag-wrapper,
.removed-filters-container {
    width: 100%;
    padding-left: 0px;
}

.search-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 20px;
}

.switcher-container {
    display: flex;
    align-items: center;
    margin-right: -37px;
}

.switcher {
    display: flex;
    align-items: center;
    gap: 10px;
}

.toggle {
    width: 40px;
    height: 20px;
    background: #41abc4;
    border-radius: 10px;
    position: relative;
    cursor: pointer;
}

.toggle-handle {
    width: 18px;
    height: 18px;
    background: #ffffff;
    border-radius: 50%;
    position: absolute;
    top: 1px;
    left: 1px;
    transition: all 0.3s;
}

.toggle-handle.right {
    left: 21px;
}

.switcher span {
    cursor: pointer;
}

.switcher span.selected {
    border-bottom: 1px solid #000;
}

.tag-wrapper,
.removed-tags-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    max-width: 100%;
}

.removed-filters-container {
    margin-top: 20px;
    display: flex;
    gap: 15px;
    border-top: 1px solid;
    padding-top: 10px;
}

.removed-tag {
    color: #fff;
    background-color: #41abc4;
    padding-left: 10px;
    padding-right: 10px;
    height: 37px;
    font-size: 18px;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    border-radius: 5px;
}

.removed-tag:hover {
    background-color: #2699b2;
    cursor: pointer;
}

.removed-tag-text {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.restore-icon {
    cursor: pointer;
    font-size: 20px;
    color: #fff;
}

.update-btn {
    align-self: self-end;
    background-color: #41abc4;
    color: #fff;
    border: none;
    height: 40px;
    padding: 0 30px;
    font-size: 18px;
    font-family: Barlow;
    border: 2px solid #fff;
    border-radius: 13px;
    margin-left: auto;
}

.update-btn:hover {
    background-color: #2699b2;
    color: #fff;
}

.link-terms-span {
    font-size: 18px;
    color: #000;
    cursor: default !important;
}

.toggle-description {
    font-size: 18px;
    color: #000;
    font-style: italic;
}

.search-result.empty {
    border-bottom: unset !important;
    padding-bottom: 0 !important;
}

.reset-search {
    text-decoration: underline;
    cursor: pointer;
    margin-left: 20px;
    text-align: left;
    text-decoration: underline;
    font: italic normal 400 18px/26px Barlow;
    letter-spacing: -0.36px;
    color: #000000;
    opacity: 1;
}

.text {
    text-align: left;
    font: normal 400 30px/36px Barlow;
    letter-spacing: -0.3px;
    color: #3c3c3c;
    opacity: 1;
}

@media (max-width: 768px) {
    .search-result {
        display: inline-grid;
        margin-top: unset;
        margin-left: unset;
        width: 100%;
        border-top: unset;
    }

    .switcher-container {
        display: none;
    }

    .text {
        font-size: 21px !important;
    }

    .update-btn {
        width: 100%;
    }

    .removed-filters-container {
        flex-direction: column;
    }
}
</style>
